"use client";
import React, { useEffect, useState } from "react";
import JobsHeader from "./JobsHeader";
import JobCard from "./JobCard";

const FeaturedJobs = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch jobs data from API
  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await fetch(
          "https://final-project-api-alpha.vercel.app/api/jobs"
        );
        const data = await response.json();
        setJobs(data); // Save data to state
      } catch (error) {
        console.error("Error fetching jobs:", error);
      } finally {
        setLoading(false); // Set loading to false when the data is fetched
      }
    };

    fetchJobs();
  }, []); // Empty dependency array to run this only once on mount

  if (loading) {
    return <div className="text-center text-lg font-semibold py-20">Loading...</div>;
  }

  // Slice the jobs array to display only the first 6 jobs
  const displayedJobs = jobs.slice(0, 6);

  return (
    <section className="px-32 pt-20 pb-20 bg-white max-md:px-16 max-md:pt-0 max-md:pb-12 max-sm:px-6 max-sm:pt-0 max-sm:pb-8">
      <link
        href="https://fonts.googleapis.com/css2?family=Clash+Display:wght@400;600&family=Epilogue:wght@400;600;700&family=Inter:wght@400&display=swap"
        rel="stylesheet"
      />
      <JobsHeader />
      <div className="grid gap-8 grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2">
        {displayedJobs.map((job) => (
          <JobCard key={job._id} {...job} />
        ))}
      </div>
    </section>
  );
};

export default FeaturedJobs;
